import { MechanicalAspectResolverBase } from './mechanical-aspect.resolver.base';
import { MechanicalAspectService } from './mechanical-aspect.service';
import { Injectable } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class MechanicalAspectResolver extends MechanicalAspectResolverBase {

  constructor(protected service: MechanicalAspectService) {
    super(service);
  }
}



